const actions = {
  GET_COMPLAINTS_DATA: 'GET_COMPLAINTS_DATA',
  GET_COMPLAINTS_DATA_SUCCESS: 'GET_COMPLAINTS_DATA_SUCCESS',
  GET_COMPLAINTS_DATA_FAILED: 'GET_COMPLAINTS_DATA_FAILED',

  GET_COMPLAINTS_TICKETS: 'GET_COMPLAINTS_TICKETS',
  GET_COMPLAINTS_TICKETS_SUCCESS: 'GET_COMPLAINTS_TICKETS_SUCCESS',
  GET_COMPLAINTS_TICKETS_FAILED: 'GET_COMPLAINTS_TICKETS_FAILED',



  // getComplaintsData: (offset, limit, search, fromDate, toDate,agentId) => ({
  //   type: actions.GET_COMPLAINTS_DATA,
  //   payload: { offset, limit, search, fromDate, toDate,agentId },
  // }),
  // getComplaintsDataSuccess: (data, totalData) => ({
  //   type: actions.GET_COMPLAINTS_DATA_SUCCESS,
  //   payload: { data, totalData },
  // }),
  // getComplaintsDataFailed: (error) => ({
  //   type: actions.GET_COMPLAINTS_DATA_FAILED,
  //   payload: { error },
  // }),

  getComplaintsTickets: (offset, limit, search, fromDate, toDate, agentId) => ({
    type: actions.GET_COMPLAINTS_TICKETS,
    payload: { offset, limit, search, fromDate, toDate, agentId },
  }),
  getComplaintsTicketsSuccess: (data, totalData) => ({
    type: actions.GET_COMPLAINTS_TICKETS_SUCCESS,
    payload: { data, totalData },
  }),
  getComplaintsTicketsFailed: (error) => ({
    type: actions.GET_COMPLAINTS_TICKETS_FAILED,
    payload: { error },
  }),


};

export default actions;
